import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={55} height={81} viewBox="0 0 55 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M26.028.75c8.102 0 14.88 2.368 19.645 6.414 4.773 4.053 7.487 9.758 7.487 16.32 0 10.68-7.29 20.807-16.241 29.908l-.005.005-9.836 9.817H54.25V80.25H.75V65.343l.22-.22L21.14 45.042c3.208-3.216 6.135-6.397 8.26-9.558 2.126-3.164 3.402-6.24 3.402-9.253 0-2.484-.765-4.456-2.25-5.814-1.495-1.367-3.824-2.208-7.139-2.208-6.25 0-12.063 3.012-18.858 10.227L3.326 29.74l-.068-1.789-.654-17.122-.011-.277.173-.217C7.306 4.612 16.602.75 26.028.75z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
